export default __webpack_public_path__ + "tldv-logo.c867535c.png";